<div class="personal-main-container">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">افزودن غذا به {{ title }}</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div class="search-btn" (click)="goSearch()">
      <div class="search-icon">
        <img src="assets/general/search-blue.svg" alt="" />
      </div>
      <div>
        <p>جست‌و‌جوی غذا</p>
      </div>
    </div>
    <div class="list">
      <div class="custome" (click)="goToPersonalFoodMain()">
        <img src="assets/general/food-package.svg" alt="" />
        <p>غذاهای شخصی</p>
      </div>
      <div
        class="custome"
        style="margin-right: 24px"
        (click)="goToPersonalPackageMain()"
      >
        <img src="assets/general/Package.svg" alt="" />
        <p>پکیج‌های شخصی</p>
      </div>
    </div>
    <div class="custome-button" (click)="addQuikC()">
      <div class="add-button">
        <img src="assets/plan/plus.svg" alt="" />
      </div>
      <p class="title">افزودن سریع کالری</p>
    </div>
  </div>
  <app-bottomsheet
    *ngIf="showBTM"
    [type]="'fastcalorie'"
    [meal]="meal"
  ></app-bottomsheet>
</div>
